// extracted by mini-css-extract-plugin
export default {"result-item":"UserSearchResults_result-item__VxPEb","avatar-label":"UserSearchResults_avatar-label__yB9SI"};